<template>
    <router-link to="/" class="logo-button flex">
        <picture class="logo-image">
            <source type="image/svg+xml" srcset="../../assets/logo.svg" />
            <img srcset="../../assets/logo.png 1x,../../assets/logo@2x.png 2x" src="../../assets/logo.png" alt="Owen Associates Interiors" />
        </picture>
        <div class="logo-text">
            <h1>Owen Associates <span>Interiors</span></h1>
        </div>
    </router-link>
</template>

<script lang="js">
    export default {
        name: "logo-button"
    };
</script>

<style>
    a.logo-button {
        position: relative;
        text-decoration: none;
        -ms-flex: 0 0 5em;
        -webkit-flex: 0 0 5em;
        flex: 0 0 5em;
        width: 5em;
        height: 5em;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        overflow: hidden;
        padding: 0;
    }

            a.logo-button picture.logo-image {
                flex-basis: 120%;
            }
                a.logo-button picture.logo-image img {
                    display: block;
                    margin-left: -7%;
                    margin-top: -23%;
                }

        a.logo-button div.logo-text {
            flex-basis: auto;
            position: absolute;
            left: 10%;
            top: 35%;
        }
            a.logo-button div.logo-text h1 {
                font-size: var(--font-size-0);
                font-weight: 400;
                line-height: 1em;
                margin: 0;
                color: var(--white1);
                text-align: left;
            }

                a.logo-button div.logo-text h1 span {
                    text-transform: uppercase;
                }

    header a.logo-button {
        background-color: var(--green1);
    }

</style>